import { Link } from "react-router";

const FOOTER_LINKS = {
  Features: [
    { label: "Domain Lookup", to: "/features/domain-lookup" },
    { label: "Brand Search", to: "/features/brand-search" },
    { label: "AI Styles", to: "/features/ai-styles" },
    { label: "Stock Tickers", to: "/features/stock-tickers" },
    { label: "Crypto Logos", to: "/features/crypto-logos" },
    { label: "Brand Profiles", to: "/features/brand-profiles" },
    { label: "Monogram Fallbacks", to: "/features/monogram-fallbacks" },
    { label: "CDN Delivery", to: "/features/cdn-delivery" },
  ],
  "Use Cases": [
    { label: "SaaS Dashboards", to: "/use-cases/saas-dashboards" },
    { label: "Fintech Apps", to: "/use-cases/fintech-apps" },
    { label: "Portfolio Trackers", to: "/use-cases/portfolio-trackers" },
    { label: "CRM Integrations", to: "/use-cases/crm-integrations" },
    { label: "Email Clients", to: "/use-cases/email-clients" },
    { label: "Browser Extensions", to: "/use-cases/browser-extensions" },
  ],
  Compare: [
    { label: "vs Clearbit", to: "/compare/clearbit" },
    { label: "vs Logo.dev", to: "/compare/logo-dev" },
    { label: "vs Brandfetch", to: "/compare/brandfetch" },
  ],
  Resources: [
    { label: "API Docs", to: "/docs" },
    { label: "Blog", to: "/blog" },
    { label: "Changelog", to: "/changelog" },
    { label: "About", to: "/about" },
  ],
  Explore: [
    { label: "ENS Avatars", to: "/ens/vitalik.eth" },
    { label: "GitHub Avatars", to: "/github/octocat" },
    { label: "Blockchains", to: "/blockchain/1" },
    { label: "Country Flags", to: "/flag/us" },
    { label: "Favicons", to: "/favicon/spotify.com" },
    { label: "Wallet Avatars", to: "/wallet/0xd8dA6BF26964aF9D7eEd9e03E53415D37aA96045" },
  ],
};

export function Footer() {
  return (
    <footer className="border-t bg-card/50">
      <div className="max-w-[1120px] mx-auto px-6 py-12">
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-8">
          {/* Brand */}
          <div className="col-span-2 sm:col-span-3 lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 font-extrabold text-foreground text-sm no-underline mb-3">
              <img src="/logo.svg" alt="LoadLogo" className="w-6 h-6" />
              LoadLogo
            </Link>
            <p className="text-xs text-muted-foreground leading-relaxed">
              The comprehensive logo API for modern developers.
            </p>
          </div>

          {/* Link columns */}
          {Object.entries(FOOTER_LINKS).map(([heading, links]) => (
            <div key={heading}>
              <h4 className="text-xs font-bold uppercase tracking-wider text-muted-foreground mb-3">{heading}</h4>
              <ul className="space-y-2">
                {links.map((link) => (
                  <li key={link.to}>
                    <Link
                      to={link.to}
                      className="text-sm text-secondary-foreground hover:text-foreground transition-colors no-underline"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom bar */}
        <div className="border-t mt-10 pt-6 flex flex-col sm:flex-row justify-between items-center gap-3">
          <p className="text-xs text-muted-foreground">
            &copy; {new Date().getFullYear()} LoadLogo. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="https://happyuptime.com/status/loadlogo" target="_blank" rel="noopener noreferrer" className="inline-flex">
              <img
                src="https://happyuptime.com/api/v1/badges/h88UHnWcoyYPUZ10qr4e4/status.svg?style=widget"
                alt="LoadLogo Status"
                height={24}
                loading="lazy"
              />
            </a>
            <Link to="/privacy" className="text-xs text-muted-foreground hover:text-foreground transition-colors no-underline">Privacy</Link>
            <Link to="/terms" className="text-xs text-muted-foreground hover:text-foreground transition-colors no-underline">Terms</Link>
            <a href="mailto:hello@loadlogo.com" className="text-xs text-muted-foreground hover:text-foreground transition-colors no-underline">Contact</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
